module.exports = __webpack_public_path__ + "img/train-subway.361fd543.svg";